
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemaps",
      function () {
        return require("private-next-pages/sitemaps/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemaps"])
      });
    }
  